var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"justify":"center"}},[_c('v-dialog',{ref:"dialog",attrs:{"max-width":_vm.width,"persistent":_vm.persistent},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }